
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { VMDutyCreate } from '../../../backend/backendapi';
import { WindowType } from "../../../../util";
import ConditionBasedMonitoring from "./ConditionBasedMonitoring";

declare var window: WindowType;

@Component({
  name: 'MiscTab',
  components: { ConditionBasedMonitoring }
})
export default class MiscTab extends Vue {
  @Prop({ required: true })
  readonly dutyCreate!: VMDutyCreate;
}
